import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { setIncorporationRequestService } from 'services/setAutorizationRequestService'
import inputValidate from 'utils/inputValidate'

const useFormInformedConsent = () => {
    const navigate = useNavigate()
    const [isFetching, setIsFetching] = useState(false)
    const initialFormState = {
        patient: {
            names: '',
            surnames: '',
            email: '',
            mobile: '',
            product: '',
            therapeuticIndication: '',
        },
        professional: {
            names: '',
            surnames: '',
            email: '',
            specialty: '',
            professionalRegistration: '',
        },
    }
    const [formState, setFormState] = useState({ ...initialFormState })
    const [formErrorsState, setFormErrorsState] = useState({
        ...initialFormState,
    })

    //* Handle Input Change
    const handleInputChange = (inputName, inputValue, fieldset, minLength) => {
        if (inputName === 'email' && fieldset === 'patient') {
            const newFormState = {
                patient:
                    fieldset === 'patient'
                        ? { ...formState.patient, [inputName]: inputValue }
                        : { ...formState.patient },
                professional:
                    fieldset === 'professional'
                        ? { ...formState.professional, [inputName]: inputValue }
                        : { ...formState.professional },
            }

            setFormState({ ...newFormState })

            setFormErrorsState((prev) => ({
                ...prev,
                [fieldset]: {
                    ...prev[fieldset],
                    [inputName]: inputValue,
                },
            }))
        } else {
            const validationResult = inputValidate({
                inputName,
                inputValue,
                minLength,
            })

            const newFormState = {
                patient:
                    fieldset === 'patient'
                        ? { ...formState.patient, [inputName]: inputValue }
                        : { ...formState.patient },
                professional:
                    fieldset === 'professional'
                        ? { ...formState.professional, [inputName]: inputValue }
                        : { ...formState.professional },
            }

            setFormState({ ...newFormState })

            setFormErrorsState((prev) => ({
                ...prev,
                [fieldset]: {
                    ...prev[fieldset],
                    [inputName]: validationResult,
                },
            }))
        }
    }

    //* Handle Reset Form
    const handleResetForm = () => {
        /* setFormState({ ...initialFormState })
        const formElement = document.getElementById('autorizationRequestForm')
        formElement.reset() */
    }

    //* Handle Submit
    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsFetching(true)
        const submitErrors = []

        Object.keys(formState.patient).forEach((input) => {
            const error =
                input === 'email'
                    ? false
                    : inputValidate({
                          inputName: input,
                          inputValue: formState.patient[input],
                      })
            if (error) {
                console.log('🚀 ~ handleSubmit ~ error:', error)
                submitErrors.push(`patient_${input}`)
                setFormErrorsState((prev) => ({
                    ...prev,
                    patient: {
                        ...prev.patient,
                        [input]: error,
                    },
                }))
            }
        })

        Object.keys(formState.professional).forEach((input) => {
            const error = inputValidate({
                inputName: input,
                inputValue: formState.professional[input],
            })

            if (error) {
                submitErrors.push(`professional_${input}`)
                setFormErrorsState((prev) => ({
                    ...prev,
                    professional: {
                        ...prev.professional,
                        [input]: error,
                    },
                }))
            }
        })

        if (submitErrors.length > 0) {
            setIsFetching(false)
        } else {
            const result = await setIncorporationRequestService({
                patient: { ...formState.patient },
                professional: { ...formState.professional },
            })
            if (result.status) {
                setTimeout(function () {
                    navigate('/')
                }, 3000)
            }
            setIsFetching(false)
        }
    }

    return {
        patientData: formState.patient,
        professionalData: formState.professional,
        errors: formErrorsState,
        isFetching,
        handleInputChange,
        handleSubmit,
    }
}

export default useFormInformedConsent
